import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { AdHocInvoiceApprovalScreen, GetAdHocInvoiceApprovalScreenTID } from './AdHocInvoiceApproval';
import styles from './AdHocInvoiceApproval.module.scss';
import { AdHocStatusViewSkeleton } from './AdHocStatusView/AdHocStatusView';
import { useApprovalEmailEntry } from './hooks/useApprovalEmailEntry';
import { useChainedInvoiceApproval } from './hooks/useChainedInvoiceApproval';
import { InvoiceStatusScreen } from './InvoiceStatusScreen/InvoiceStatusScreen';
export const AdHocInvoiceApprovalPage = (props)=>{
    const { testId } = props;
    const { t: allHandledTexts } = useLocaleKeys('invoice.adHocApproval.chainedApproval.allHandled');
    const { payload } = useApprovalEmailEntry();
    const { AdHocInvoiceApprovalTestIds } = GetAdHocInvoiceApprovalScreenTID(testId);
    const { invoiceId, chainedApproval, allHandled, onInvoiceApproved } = useChainedInvoiceApproval(payload);
    if (payload == null) {
        return /*#__PURE__*/ _jsx(AdHocStatusViewSkeleton, {
            testId: AdHocInvoiceApprovalTestIds.AdHocStatusView()
        });
    }
    if (allHandled) {
        return /*#__PURE__*/ _jsx(Box, {
            testId: AdHocInvoiceApprovalTestIds.Root(),
            className: styles.statusViewRoot,
            children: /*#__PURE__*/ _jsx(InvoiceStatusScreen, {
                testId: AdHocInvoiceApprovalTestIds.InvoiceStatusScreen(),
                title: allHandledTexts.title(),
                subtitle: allHandledTexts.body()
            })
        });
    }
    return /*#__PURE__*/ _jsx(AdHocInvoiceApprovalScreen, {
        testId: testId,
        invoiceId: invoiceId,
        vendorName: payload.invoice.vendorName,
        chainedApproval: chainedApproval,
        onApproved: onInvoiceApproved
    }, invoiceId);
};
